// Important: The order of the spacing MUST stay the same. Do not add extra values to the array. If the value on the design is not shown in the array, consult the design team on amending to fit with the style system.
export const space = {
    spacing: [0, 4, 6, 8, 10, 12, 16, 20, 24, 26, 30, 32, 40, 50, 60]
}

// Example usage: theme.spacing(5) would return 12px
// pt={8} would return padding-top: 24px